import intlTelInput from "intl-tel-input";
import { uk } from "intl-tel-input/i18n";

export function inputTel({ form }) {
  return {
    iti: null,
    init() {
      const input = this.$el;

      if (this.iti) this.iti.destroy();

      this.iti = intlTelInput(input, {
        i18n: uk,
        initialCountry: 'auto',
        strictMode: true,
        separateDialCode: true,
        loadUtils: () => import('intl-tel-input/utils'),
        geoIpLookup: (success, failure) => {
          fetch('https://ipapi.co/json')
            .then(res => res.json())
            .then(data => success(data.country_code))
            .catch(failure);
        }
      });

      input.addEventListener('countrychange', () => {
        this.iti.setNumber('');
        form.phone = '';
      });

      input.addEventListener('input', () => {
        form.phone = this.iti.getNumber();
      });
    },
  };
}
